<template>
<div>
    <invoice-reminder-form :getInvoiceReminderListByInvoiceId="getInvoiceReminderListByInvoiceId" ref="invoiceReminderFormModal"></invoice-reminder-form>
    <b-card>
        <template #header>
            <div class="d-flex justify-content-between align-items-center w-100">
                <h5 class="mb-0">{{ $t('invoiceReminder.reminder_history') }}</h5>
                <b-button variant="primary" size="sm" @click="getInfo(0)">
                    <feather-icon icon="Plus" size="16" class="mr-1" />
                    {{ $t('invoiceReminder.add_reminder') }}
                </b-button>
            </div>
        </template>
        <vue-good-table :columns="columns" :rows="reminderList" styleClass="vgt-table condensed tableSize" theme="my-theme">
            <div slot="emptystate">
                {{ $t('dataTable.data_not_found') }}
            </div>
            <template slot="table-column" slot-scope="props">
                <span v-if="props.column.field === 'reminderNumber'">{{ $t('invoiceReminder.number') }}</span>
                <span v-else-if="props.column.field === 'reminderSendDate'">{{ $t('invoiceReminder.send_date') }}</span>
                <span v-else-if="props.column.field === 'agentResponseDate'">{{ $t('invoiceReminder.response_date') }}</span>
                <span v-else-if="props.column.field === 'employeeName'">{{ $t('invoiceReminder.employee') }}</span>
                <span v-else-if="props.column.field === 'note'">{{ $t('invoiceReminder.note') }}</span>
                <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                    {{ $t('others.process') }}
                </span>
            </template>
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'reminderNumber'" class="text-center">
                    <b-badge variant="primary">{{ props.row.reminderNumber }}</b-badge>
                </span>
                <span v-else-if="props.column.field === 'reminderSendDate'">
                    {{ $formatFn(props.row.reminderSendDate) }}
                </span>
                <span v-else-if="props.column.field === 'agentResponseDate'">
                    <b-badge v-if="props.row.agentResponseDate" variant="success">
                        {{ $formatFn(props.row.agentResponseDate) }}
                    </b-badge>
                    <b-badge v-else variant="warning">
                        {{ $t('invoiceReminder.pending') }}
                    </b-badge>
                </span>
                <span v-else-if="props.column.field === 'employeeName'">
                    {{ props.row.employeeName }}
                </span>
                <span v-else-if="props.column.field === 'note'">
                    <small>{{ props.row.note }}</small>
                </span>
                <span v-if="props.column.field === 'process'">
                    <span>
                        <b-button v-b-tooltip.html :title="$t('others.edit')" variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.id)">
                            <feather-icon icon="EditIcon" />
                        </b-button>
                        <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1" size="sm" @click="deleted(props.row)">
                            <feather-icon icon="XIcon" />
                        </b-button>
                    </span>
                </span>
            </template>
        </vue-good-table>
    </b-card>
</div>
</template>

<script>
export default {
    props: {
        invoiceId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            reminderList: [],
            columns: [
                {
                    label: 'No.',
                    field: 'reminderNumber',
                    width: '60px'
                },
                {
                    label: 'Send Date',
                    field: 'reminderSendDate'
                },
                {
                    label: 'Response Date',
                    field: 'agentResponseDate'
                },
                {
                    label: 'Employee',
                    field: 'employeeName'
                },
                {
                    label: 'Note',
                    field: 'note'
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '10em'
                }
            ]
        }
    },
    methods: {
        getInfo(reminderId) {
            this.$refs.invoiceReminderFormModal.showInfo(reminderId, this.invoiceId)
        },
        getInvoiceReminderListByInvoiceId() {
            const data = {
                id: this.invoiceId
            }
            const controller = {
                name: 'InvoiceReminder',
                actionName: 'GetInvoiceReminderListByInvoiceId'
            }
            const payload = {
                data,
                controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus) {
                    this.reminderList = response.data.invoiceReminderList || []
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        deleted(reminder) {
            this.$DeleteConfirm().then(result => {
                if (result.value) {
                    const data = {
                        id: reminder.id
                    }
                    const controller = {
                        name: 'InvoiceReminder'
                    }
                    const payload = {
                        data,
                        controller
                    }

                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus) {
                            this.$DeleteAlert()
                            this.getInvoiceReminderListByInvoiceId()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        }
    },
    mounted() {
        this.getInvoiceReminderListByInvoiceId()
    }
}
</script>

<style lang="scss" scoped>
</style>
